import { render, staticRenderFns } from "./ad-status-edit.vue?vue&type=template&id=3f1674aa"
import script from "./ad-status-edit.vue?vue&type=script&lang=js"
export * from "./ad-status-edit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2251928234/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3f1674aa')) {
      api.createRecord('3f1674aa', component.options)
    } else {
      api.reload('3f1674aa', component.options)
    }
    module.hot.accept("./ad-status-edit.vue?vue&type=template&id=3f1674aa", function () {
      api.rerender('3f1674aa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ads/ad-status-edit.vue"
export default component.exports